import api from '@/api/endpoints'
import { getInstance } from '@/auth/auth0-plugin'

const state = {
  sources: []
}

const getters = {
  sources(getterState) {
    return getterState.sources
  },
  getSourceName: (getterState) => (source_id) => {
    const match = getterState.sources.find(
      (s) => s && s.source_id === source_id
    )
    return match ? match.display_name : source_id
  }
}

const mutations = {
  set_sources (mutationState, payload) {
    mutationState.sources = payload
  }
}

const actions = {
  async setSources (context) {
    if (context.getters.sources.length === 0) {
      const authService = getInstance()
      let isRetailer = false
      if (authService.tenant === 'jbg' && !authService.isAdmin) {
        isRetailer = authService.userRoles.includes('jbg-retailer')
      }
      let sourcesArr = []
      try {
        const data = await api.getSources()
        if (data && data.length > 0) {
          sourcesArr = data.map(source => {
            return {
              ...source,
              display_name: (isRetailer && source.source_id.startsWith('dd'))
                ? 'Crossdock'
                : source.source_name
            }
          })
        }
        context.commit('set_sources', sourcesArr)
      } catch (err) {
        console.error(err)
      }
    }
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/source.js